import request from "@/utiles/axios";
/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(data = {}) {
  return request({
    url: "/dept/deptTree",
    method: "post",
    data: data,
  });
}

/**
* 查询用户
* @param {*} data
* @returns
*/
export function getPage(data) {
  return request({
    url: "/pc/case/caseInfoPageList",
    method: "post",
    data: data,
  });
}
/**
* 理赔案件导出
* @param {*} data
* @returns
*/
export function caseExport(data,fileName) {
  return request({
    url: "/pc/case/caseExport",
    method: "post",
    data: data,
    responseType: "blob",
    fileName
  });
}

// 退回采集
export function backCollection(data) {
  return request({
    url: "/pc/case/backCollection",
    method: "post",
    data,
  });
}

//推送数据
export function pushData(data) {
  return request({
    url: `/pc/case/pushCase?id=${data}`,
    method: "post",
    data,
  });
}

export function waterPic(data) {
    return request({
        url: "/pc/case/waterPics",
        method: "post",
        data: data,
    });
}
